var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"no-menu":"","folded":false,"no-title":"","hfull":""}},[_c('group-form',{attrs:{"group-id":_vm.$route.params.id,"full":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }